import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  nonEditable: {
    fontWeight: 'bold',
    display: 'block',
    margin: '4rem 0 1.5rem 1rem',
  },
  formControl: {
    minWidth: '100%',
    '& label': {
      color: theme.palette.form.labelColor,
      fontSize: theme.typography.pxToRem(14),
      marginLeft: 16,
      '&.MuiFormLabel-filled': {
        color: theme.palette.form.labelFilledColor,
        fontSize: theme.typography.pxToRem(13),
        marginLeft: 0,
      },
      '&.Mui-focused': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(13),
        marginLeft: 0,
      },
    },
    '& .MuiInput-formControl': {
      '& .MuiSelect-select': {
        padding: '6px 24px 6px 16px',
      },
    },
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(14),
  },
  menuItemOption: {
    minHeight: 30,
    fontSize: theme.typography.pxToRem(14),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
